'use strict';

export const   setAppReady = state => { state.isAppReady = true  }
export const unsetAppReady = state => { state.isAppReady = false }

//=================================================================================================================

export const setStaticAppData = (state, data) => {
	Object.assign(state, data);
};

//=================================================================================================================

export const setDisclaimer = (state, { disclaimer }) => {
	state.disclaimer = disclaimer;
};

//=================================================================================================================

export const toggleNavPane = (state, visible) => {
	state.navPaneVisible = visible != null ? visible : !state.navPaneVisible;
};

//=================================================================================================================

// const toggleLoggingState = (state, isLogging) => {
// 	state.login.loading = isLogging;
// };

// //=================================================================================================================

// const setUser = (state, { user }) => {
// 	state.login.user = user;
// }

// //=================================================================================================================

// const toggleLoadingState = (state, isLoading) => {
// 	state.loading = isLoading;
// };

//=================================================================================================================

export const setView = (state, { view }) => {
	state.view = view;
};

//=================================================================================================================

// const registerActions = (state, { actions }) => {
// 	const newActionsByID = arrayToObj(actions, 'id');
// 	const allActionsByID = { ...state.registry.actions.byID, ...newActionsByID };
// 	const allActionsFlat = objToArray(allActionsByID);

// 	// compute categories
// 	const categoriesByID = allActionsFlat.reduce((map, { category }) => {
// 		const item = map[category] || (map[category] = { name: category, count: 0 });
// 		++item.count;
// 		return map;
// 	}, {});
// 	const categories = objToArray(categoriesByID)
// 	categories.sort((a, b) => {
// 		if (a.name < b.name) { return -1 }
// 		if (a.name > b.name) { return +1 }
// 		return 0;
// 	});

// 	// compute popular actions
// 	const allActionsPopular = [].concat(allActionsFlat)
// 		.sort((a, b) => {
// 			if (a.likes > b.likes) { return -1 }
// 			if (a.likes < b.likes) { return +1 }
// 			return 0;
// 		})
// 		.slice(0, 10);

// 	// compute risky actions
// 	const allActionsByRisk = allActionsFlat.reduce((map, item) => {
// 		map[item.risk].push(item);
// 		return map;
// 	}, { 1: [], 2: [], 3: [], 4: [], 5: [] });


// 	// update state
// 	state.registry.actions.byID = allActionsByID;
// 	state.registry.actions.flat = allActionsFlat;
// 	state.registry.actions.popular = allActionsPopular;
// 	state.registry.actions.byRisk = allActionsByRisk;
// 	state.registry.categories = categories;

// 	state.selection = actions; // extract this to an action "select" ?
// };

// //=================================================================================================================

// const selectCategory = (state, { category }) => {
// 	state.selection = state.registry.actions.flat.filter(item => item.category === category);
// };

// //=================================================================================================================

// const selectAll = (state) => {
// 	state.selection = state.registry.actions.flat;
// };

// //=================================================================================================================

// const selectPopular = (state) => {
// 	state.selection = state.registry.actions.popular;
// };

// //=================================================================================================================

// const selectRisk = (state, { risk }) => {
// 	state.selection = state.registry.actions.byRisk[risk];
// };
